<template>
  <div class="game-switcher" v-click-outside="close">
    <div class="game-switcher_item game-switcher_item__header" @click="toggle">
      <div class="game-switcher_inner">
        <img :class="['game-switcher_value', 'game-switcher_value_' + selectedGame]" :src="getGameImgUrl(selectedGame)" :alt="$t(selectedGameTitle)" v-if="selectedGame">
        <span class="game-switcher_value" v-else>{{ $t('Все игры') }}</span>
        <span
          :class="[{ 'game-switcher_icon__open': show }, 'game-switcher_icon']"
        >
        </span>
      </div>
    </div>
    <Transition name="game-switcher_animate">
      <ul class="game-switcher_dropdown" v-show="show">
        <li
          :class="[{'game-switcher_item__selected': game === selectedGame}, 'game-switcher_item']"
          v-for="(title, game) in games"
          :key="game"
          @click="onSelect(game)"
        >
          <div class="game-switcher_inner">
            <img :class="['game-switcher_value', 'game-switcher_value_' + game]" :src="getGameImgUrl(game)" :alt="$t(title)">
          </div>
        </li>
      </ul>
    </Transition>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import vClickOutside from 'v-click-outside'

import { GAME_NAMES } from '@/constants'

@Component({
  directives: {
    clickOutside: vClickOutside.directive
  }
})
class GameSwitcher extends Vue {
  @Prop({ type: String }) selectedGame

  games = {
    ...GAME_NAMES
  }
  show = false

  get selectedGameTitle () {
    return this.games[this.selectedGame]
  }

  getGameImgUrl (game) {
    return require('./img/' + game + '.svg')
  }

  toggle () {
    this.show = !this.show
  }

  close () {
    this.show = false
  }

  onSelect (game) {
    this.toggle()
    this.$emit('game-change', game)
  }
}

export default GameSwitcher
</script>

<style lang="scss" src="./game-switcher.scss" />
